// biome-ignore lint/correctness/noUndeclaredVariables: allow unused
__webpack_public_path__ = process.env.ASSET_PATH;
